import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
    {
        path: '/setUpAlumnus',
        component: LAYOUT,
        redirect: '/setUpAlumnus/inChina',
        meta: { title: '创业校友', showNavPanel: true },
        children: [
            {
                path: 'inChina',
                name: '国内创业校友',
                component: () => import('@/views/setUpAlumnus/inChina.vue'),
                meta: { title: '国内创业校友' },
            },
            {
                path: 'outOfChina',
                name: '国外创业校友',
                component: () => import('@/views/setUpAlumnus/outOfChina.vue'),
                meta: { title: '国外创业校友' },
            },
            // {
            //     path: 'products',
            //     name: '品牌产品',
            //     component: () => import('@/views/setUpAlumnus/products.vue'),
            //     meta: { title: '品牌产品' },
            // },
            // {
            //     path: 'shopMall',
            //     name: '校友商城',
            //     component: () => import('@/views/setUpAlumnus/shopMall.vue'),
            //     meta: { title: '校友商城' },
            // },
        ],
    },
]
